import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ToastService} from "../../../services/Toast.service";
import {TaxPlanningService} from "../../../tpiq-services/tax-planning.service";
import {NumeralService} from "../../../services/Numeral.service";
import {Session} from "../../../services/Session";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SuggestFeeComponent} from "./suggest-fee/suggest-fee.component";
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {AddNewFeeComponent} from "./add-new-fee/add-new-fee.component";

declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-fee-lines',
  standalone: true,
  imports: [CommonModule, FormsModule, SuggestFeeComponent, TpiqSelectDropdownComponent, AddNewFeeComponent],
  templateUrl: './fee-lines.component.html',
  styleUrl: './fee-lines.component.scss'
})
export class FeeLinesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() costLines: any;
  @Input() associatedWith: any;
  @Input() clientUserId: any;
  @Input() planYearFilter: any;
  @Input() taxStrategyId: any;
  @Input() freezPlan: any;
  @Input() userReadOnly: any;
  @Input() clientTaxPlan: any;
  @Output() onCreationOrUpdateOfCostLine: EventEmitter<any> = new EventEmitter<any>();

  feesTableData: any = {};
  org: string = Session.getOrg();
  user: any = {};
  columns: Array<any> = [
    {name: 'type', title: 'Investment Type', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'description', title: 'Description', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'amount', title: 'Amount', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'associatedWithRate', title: 'Rate', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'frequency', title: 'Frequency', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'year', title: 'Year', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
  ];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  reveal: any = {
    addNewFeeLine: false,
    implementationFee: false
  };
  costLine = {};
  feePeriods: Array<any> = [{name: 'Monthly'}, {name: 'Yearly'}, {name: 'Custom'}];
  feeTypes: Array<any> = [{name: 'One Time'}, {name: 'Recurring'}, {name: 'Pre Paid'}, {name: 'Priceless'}, {name: 'Third Party'}];
  years: Array<any> = [];
  editMode: boolean = false;
  currentEditRowData: any;
  orgName: string;
  showImplementFeeSection: boolean = false;
  @ViewChild('roiFeeInfo') roiFeeInfo;

  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private taxPlanningService: TaxPlanningService,
    private numeralService: NumeralService,
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.orgName = this.user.org || '';
    this.fillYears();
    this.formRowsDataForTable();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

ngOnChanges(changes: SimpleChanges): void {
  if (changes['costLines'] && changes['costLines'].currentValue) {
    this.formRowsDataForTable();
  }
}

  formRowsDataForTable() {
    const data = _.cloneDeep(this.costLines);
    if (data && data.length > 0) {
      _.each(data, (line) => {
        line.amount = this.numeralService.format('$0,0', line.amount);
        const obj = _.find(this.associatedWith, {id: line.associatedWith});
        line.associatedWithRate = (obj) ? obj.name : '';
      });
    }
    this.feesTableData = data;
  }


  hideReveal(key){
    this.costLine = {};
    this.editMode = false;
    this.currentEditRowData = '';
    this.showImplementFeeSection = false;
    this.reveal[key] = false;
  }

  addNewFeeLine() {
    this.reveal.addNewFeeLine = true;
    this.costLine = {
      userId: this.clientUserId,
      frequency: 'Yearly',
      year: parseInt(this.planYearFilter),
      associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
    };
  }

  setAssociatedWithForFeeItem($event, costLine) {
    costLine.associatedWith = $event.id;
  }

  setPeriod($event, costLine){
    costLine.frequency = $event.name;
  }

  setYear($event, costLine){
    costLine.year = $event.id;
  }

  setFeeType($event, costLine){
    costLine.type = $event.name;
    costLine.frequency = "";
  }

  fillYears(){
    const startYear: any = _.toNumber(this.planYearFilter);
    const endYear: any = startYear + 10;
    for (let i = startYear; i < endYear; i++){
      this.years.push({id: i, name: i.toString()});
    }
  }

  saveFee($event) {
    if (!this.roiFeeInfo.feeLineData.description || this.roiFeeInfo.feeLineData.description.trim() === '') {
      const base = this;
      base.toastService.pop(TOAST_TYPE.error, 'Description cannot be empty');
      return;
      }

    let proposedFeeLine = _.cloneDeep(this.roiFeeInfo.feeLineData);
    if (proposedFeeLine.type !== 'Pre Paid') {
      proposedFeeLine.amount = this.roiFeeInfo.finalY1ImplementationValue || 0;
      proposedFeeLine.frequency = this.roiFeeInfo.feeLineData.frequency;
      let calcString = _.cloneDeep(this.roiFeeInfo.implementationFeeTypes);
      proposedFeeLine.implementationCalc = JSON.stringify(calcString);
    }
    // The third-party fee is persisted as its own 'Third Party' cost line, never
    // as a field on the fee line itself.
    const thirdPartyAmount = Number(this.roiFeeInfo.feeLineData.thirdPartyFee) || 0;
    delete proposedFeeLine.thirdPartyFee;

    const costLinesData = _.cloneDeep(this.costLines);
    if (!this.editMode) {
      if (this.roiFeeInfo.feeLineData.amount && this.roiFeeInfo.feeLineData.amount > 0) {
        costLinesData.push({
          type: 'Pre Paid',
          amount: this.roiFeeInfo.feeLineData.amount,
          description: 'Prior year fee paid',
          frequency: this.roiFeeInfo.feeLineData.frequency,
          year: this.clientTaxPlan.taxYear,
          associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
        });
      }
      if (thirdPartyAmount > 0) {
        costLinesData.push({
          type: 'Third Party',
          amount: thirdPartyAmount,
          description: 'Third party fee',
          frequency: this.roiFeeInfo.feeLineData.frequency,
          year: this.clientTaxPlan.taxYear,
          associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
        });
      }
      costLinesData.push(proposedFeeLine);
    } else if (this.editMode) {
      if (this.roiFeeInfo.feeLineData.type === 'Third Party') {
        proposedFeeLine.amount = thirdPartyAmount;
      }
       if (this.roiFeeInfo.feeLineData.frequency !== 'Custom') {
        this.roiFeeInfo.feeLineData.fromMonth = null;
        this.roiFeeInfo.feeLineData.toMonth = null;
      }
      const feeIndex = _.findIndex(costLinesData, {id: this.currentEditRowData.id});
      if (feeIndex != -1) {
        costLinesData[feeIndex] = proposedFeeLine;
      }
      // Keep the separate 'Third Party' cost line in sync with the edited value:
      // update it in place, create it if missing, remove it when cleared. Skip when
      // the edited line IS the Third Party line (handled by the amount swap above).
      if (proposedFeeLine.type !== 'Third Party') {
        const thirdPartyIndex = _.findIndex(costLinesData, {type: 'Third Party'});
        if (thirdPartyAmount > 0) {
          if (thirdPartyIndex != -1) {
            costLinesData[thirdPartyIndex].amount = thirdPartyAmount;
          } else {
            costLinesData.push({
              type: 'Third Party',
              amount: thirdPartyAmount,
              description: 'Third party fee',
              frequency: proposedFeeLine.frequency,
              year: this.clientTaxPlan.taxYear,
              associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
            });
          }
        } else if (thirdPartyIndex != -1) {
          costLinesData.splice(thirdPartyIndex, 1);
        }
      }
    }
    _.each(costLinesData, (cost) => {
      if (cost.fromMonth) {
        cost.fromMonth = moment(cost.fromMonth).format('MM/DD/YYYY');
      }
      if (cost.toMonth) {
        cost.toMonth = moment(cost.toMonth).format('MM/DD/YYYY');
      }
    });
    if (!this.validateCostLines(costLinesData)){
      return false;
    }

    this.saveFeeLines(costLinesData);
  }

  validateCostLines(costData){
    const base = this;
    let isFineToSave = true;
    _.each(costData, (costLine) => {
      if (!costLine.type) {
        base.toastService.pop(TOAST_TYPE.error, 'Type cannot be empty');
        isFineToSave = false;
      } else if (costLine.type == 'Recurring') {
        if (costLine.frequency == 'Custom') {
          if (!costLine.fromMonth) {
            isFineToSave = false;
            base.toastService.pop(TOAST_TYPE.error, 'Start date cannot be empty');
          } else if (!costLine.toMonth) {
            isFineToSave = false;
            base.toastService.pop(TOAST_TYPE.error, 'End date cannot be empty');
          }
        } else if (!costLine.year) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Year cannot be empty');
        }
      } else if (costLine.type != 'Priceless') {
        if (!costLine.year) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Year cannot be empty');
        } else if (!costLine.associatedWith) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Please select an associated with rate');
        }
      }
    });
    return isFineToSave;
  }

  onDate($event) {
    console.log($event);
  }

  deleteFeeLine(index) {
    this.feesTableData.splice(index, 1);
    this.costLines.splice(index, 1);
    this.saveFeeLines(this.costLines);
  }

  saveFeeLines(data) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateCostLines(this.org, this.user.id, this.taxStrategyId, data)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.costLines = response;
          this.formRowsDataForTable();
          this.hideReveal('addNewFeeLine');
          this.onCreationOrUpdateOfCostLine.emit();
          this.toastService.pop(TOAST_TYPE.success, 'Fees updated successfully');
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update Fees');
        }
      });
  }

  editFee(row, index) {
    this.editMode = true;
    this.reveal.addNewFeeLine = true;
    // Edit from the raw cost line, not the display row — feesTableData amounts
    // are formatted strings ("$1,234") which break numeric fee calculations.
    this.costLine = _.cloneDeep(this.costLines[index]);
    this.currentEditRowData = this.costLines[index];
  }

  openIgnition(costLineData) {
    if (costLineData.proposalUrl) {
      window.open(costLineData.proposalUrl, '_blank');
    } else {
      this.toastService.pop(TOAST_TYPE.warning, 'No mapped proposal found');
    }
  }

  openImplementationFeePopup(type?) {
    if (type) {
      this.showImplementFeeSection = !this.showImplementFeeSection;
    } else {
      this.reveal.implementationFee = true;
    }
  }

}
